// extracted by mini-css-extract-plugin
module.exports = {"freeWriteBadge":"PostHeader_freeWriteBadge__1-2kv"};